import { Reference, ReferenceProps } from 'common/reference/reference.js';
import { MaybeCustomObservationType } from 'components-modules/observations/shared/observations-custom.js';
import { ILink } from 'types/navigation.js';
import { IImageLinkCore } from 'utilities/image/image.js';
import { ActivityObservations } from './activity-observations.js';
import { ActivitySummary, ActivitySummaryProps } from './activity-summary.js';

export type ActivityTypeCustom = {
  intro: string;
  items: MaybeCustomObservationType[];
  summary: ActivitySummaryProps;
  link?: ILink;
  sponsor?: ReferenceProps;
  attribution?: IImageLinkCore;
};

export const ActivityDesc = ({ intro, items, summary, sponsor }: ActivityTypeCustom) => {
  return (
    <div className="u-mT-xs">
      <ActivityObservations items={items} intro={intro} />
      <ActivitySummary {...summary} />
      <Reference {...sponsor} classes="u-mT-sm" />
    </div>
  );
};
